import {Service} from "@/services/Service";

export class UserService extends Service {
    constructor(axios) {
        super(axios, "");
        // this.fields = [
        //     "username": this.$localStorageService.,
        //     "password": "",
        // ]
    }

    login(username, password) {
        this.onStart();
        this.queryparams = {
                "username": username,
                "password": password,
        };
        return this.http.post(this.getUrl(['/token/']), this.queryparams)
            .then((response) => response.data)
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

    me() {
        this.onStart();
        return this.http.get(this.getUrl(['/me/']))
            .then((response) => JSON.parse(response.data))
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

}